import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { usePromoterCRUDActions } from '@mm/state/actions/PromoterCRUDActions';
import {
  selectFacebookOptIns,
  selectShareLinks,
} from '@mm/state/selectors/promoterSelector';
import { getFbPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import {
  textByType,
  titleByType,
} from '../../build/constants/getPromoterValue';
import { CustomisedPromoterModel, getValueByType } from '../helpers/helpers';

export type PromotersType = 'share-links' | 'facebook-opt-ins' | 'optin';

export const usePrimeState = (botId: number, promotersType: PromotersType) => {
  const promoterCRUDActions = usePromoterCRUDActions();
  const promotersSelector =
    promotersType === 'share-links' ? selectShareLinks : selectFacebookOptIns;

  const promoters = useSelector(promotersSelector);
  const env = useSelector((state: StoreState) => state.env);
  const fbPageId = useSelector(getFbPageIdSelector);

  const mappedPromoters = useMemo(() => {
    const filteredPromoters = promoters.filter(promoter => !promoter.hidden);

    return filteredPromoters.map((promoter: CustomisedPromoterModel) => {
      const { id, active, name, type, pageId, updatedAt } = promoter;

      const typeTitle = textByType.get(type);

      const valueInfo = getValueByType({
        promoter,
        fbPageId,
        appId: env.fbAppId,
        type,
        globalJavascriptBaseUrl: env.globalJavascriptBaseUrl,
      });
      const valueTitle = `Copy ${titleByType.get(type)}`;

      return {
        id,
        active,
        name,
        typeTitle,
        value: { copyable: valueInfo, title: valueTitle },
        updatedAt,
        pageId,
      };
    });
  }, [promoters]);

  useEffect(() => {
    const filter =
      promotersType === 'share-links' ? 'link' : 'checkbox, send_to_messenger';
    promoterCRUDActions.retrieveAll(botId, filter);
  }, [promotersType]);

  return { promoters, mappedPromoters };
};
